// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@stoneage/XDL/types";
import { autoClamp } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import { specialClassesStyles } from "@stoneage/XDL/PreStyle/globalStyle";
import { fontConfig, isWarthog } from "@stoneage/XDL/constants";

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
        color: "text",
        css: css`
            line-height: 28px;
        `,
    },
    p: {
        size: "16px",
        weight: fontConfig.weight.regular,
        css: css`
            line-height: 28px;
            margin-bottom: 16px;
            display: block;
            letter-spacing: 0;
        `,
    },
    h1: {
        fontFamily: fontConfig.fontFamily,
        size: "44px",
        weight: fontConfig.weight.black,
        lineHeight: autoClamp(42, 48, 52),
        color: fontConfig.headingColor,
        css: css`
            font-size: ${autoClamp(36, 40, 44)};
            margin-bottom: 20px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h2: {
        fontFamily: fontConfig.fontFamily,
        size: "36px",
        weight: fontConfig.weight.black,
        lineHeight: autoClamp(33, 38, 42),
        color: fontConfig.headingColor,
        css: css`
            font-size: ${autoClamp(28, 32, 36)};
            margin-bottom: 20px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h3: {
        fontFamily: fontConfig.fontFamily,
        size: "24px",
        weight: fontConfig.weight.bold,
        lineHeight: autoClamp(24, 26, 28),
        color: fontConfig.headingColor,
        css: css`
            font-size: ${autoClamp(20, 22, 24)};
            margin-bottom: 16px;
            letter-spacing: 0;
            display: block;
        `,
    },
    h4: {
        size: "18px",
        lineHeight: "21px",
        weight: fontConfig.weight.bold,
        color: fontConfig.headingColor,
        css: css`
            margin-bottom: 12px;
            display: block;
        `,
    },
    h5: {
        size: "16px",
        lineHeight: "19px",
        weight: fontConfig.weight.bold,
        color: fontConfig.headingColor,
        css: css`
            margin-bottom: 12px;
            display: block;
        `,
    },
    h6: {
        size: "14px",
        lineHeight: "16px",
        weight: fontConfig.weight.bold,
        color: fontConfig.headingColor,
        css: css`
            margin-bottom: 12px;
            display: block;
            letter-spacing: 0;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        transform: "uppercase",
        weight: fontConfig.weight.bold,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.main",
        transform: "uppercase",
        weight: fontConfig.weight.bold,
    },
    "&&& div.fr-wrapper": {
        css: css`
            ${specialClassesStyles}
            .as-white {
                text-shadow: 0 0 6px rgba(0, 0, 0, 0.6);
            }
        `,
    },
} as xBaseTheme["typography"];
